import { Pagination } from '@consta/uikit/Pagination'
import { Match, Show, Switch } from '@library/components'
import type { FC } from 'react'
import { useState } from 'react'

import { ProjectsCardsView } from './ProjectsCardsView'
import { ProjectsGridView } from './ProjectsGridView'
import css from './ProjectsView.css'
import { SortFilter } from './SortFilter'
import type { ItemSwitchViewGroupType } from './types'
import { itemsSwitchViewGroup, SwitchViewGroup } from './types'
import { useProjects } from './useProjects'

export const ProjectsView: FC = () => {
  const [query, setQuery] = useState('')
  const [valueSwitchViewGroup, setValueSwitchViewGroup] = useState<ItemSwitchViewGroupType>(
    itemsSwitchViewGroup[0],
  )

  const { currentPage, handleChangePage, pageCount, pageData, toggleFavorite, hasPagination } =
    useProjects(query)

  return (
    <>
      <SortFilter
        valueSwitchViewGroup={valueSwitchViewGroup}
        setValueSwitchViewGroup={setValueSwitchViewGroup}
        itemsSwitchViewGroup={itemsSwitchViewGroup}
        setQuery={setQuery}
      />
      <Switch>
        <Match when={valueSwitchViewGroup.name === SwitchViewGroup.TABLE}>
          <ProjectsGridView projects={pageData} toggleFavorite={toggleFavorite} />
        </Match>
        <Match when={valueSwitchViewGroup.name === SwitchViewGroup.CARDS}>
          <ProjectsCardsView projects={pageData} toggleFavorite={toggleFavorite} />
        </Match>
      </Switch>

      <Show when={hasPagination}>
        <Pagination
          className={css.pagination}
          size="s"
          items={pageCount}
          value={currentPage}
          onChange={handleChangePage}
        />
      </Show>
    </>
  )
}
